import { isValidDate } from "helpers/date";

const validate = (values = {}) => {
	const errors = {};

	if (!values.hirer) errors.hirer = "Informe o contratante";
	if (!values.hired) errors.hired = "Informe o prestador";
	if (!values.contractType) errors.contractType = "Informe o tipo do contrato";
	if (!values.role) errors.role = "Informe a função";
	if (!values.activitiesDescription)
		errors.activitiesDescription = "Informe a descrição das atividades";
	if (!values.startDate || !isValidDate(values.startDate))
		errors.startDate = "Informe uma data válida";
	if (!values.paymentDate) errors.paymentDate = "Informe a data de pagamento";
	if (!values.lifespan) errors.lifespan = "Informe a vigência do contrato";

	return errors;
};

export default validate;
